import React from 'react';
import styles from './Button.module.css';

export function PrimaryButton({ children, loading, ...props }) {
  return (
    <button className={styles.primary} disabled={loading || props.disabled} {...props}>
      {loading ? <span className={styles.spin} /> : children}
    </button>
  );
}

export function SecondaryButton({ children, ...props }) {
  return (
    <button className={styles.secondary} {...props}>
      {children}
    </button>
  );
}

export function WppButton({ children, ...props }) {
  return (
    <button className={styles.wpp} {...props}>
      <WppIcon />
      {children}
    </button>
  );
}

function WppIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="white" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.096.537 4.066 1.479 5.786L.057 23.926a.5.5 0 00.612.612l6.14-1.422A11.942 11.942 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.8 9.8 0 01-5.034-1.39l-.36-.214-3.732.865.882-3.617-.235-.373A9.818 9.818 0 112 12c0 5.413 4.405 9.818 9.818 9.818H12z" />
    </svg>
  );
}
